import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../contexts/AuthContext'

const MESES = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez']

const ACOES = {
  login: 'Login',
  resultado_salvo: 'Resultado salvo',
  fca_criado: 'FCA criado',
  fca_atualizado: 'FCA atualizado',
  fca_data_alterada: 'Data alterada (FCA)',
}

function formatDate(iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })
}

function formatDetalhe(acao, detalhe) {
  if (!detalhe) return '—'
  if (acao === 'login') return detalhe.email || '—'
  if (acao === 'resultado_salvo') {
    const meses = (detalhe.meses || []).map(m => MESES[m - 1]).join(', ')
    return `${detalhe.indicador || ''} · ${detalhe.ano || ''} · ${meses}`
  }
  if (acao === 'fca_criado')
    return `${detalhe.indicador || ''} · ${MESES[(detalhe.mes || 1) - 1]}/${detalhe.ano || ''}`
  if (acao === 'fca_atualizado') {
    const campos = Object.keys(detalhe.alteracoes || {}).join(', ')
    return `${detalhe.indicador || ''} · ${MESES[(detalhe.mes || 1) - 1]}/${detalhe.ano || ''}${campos ? ` · alterou: ${campos}` : ''}`
  }
  if (acao === 'fca_data_alterada') {
    const CAMPO_LABEL = { quando: 'Quando fazer', agenda_critica: 'Agenda crítica' }
    const partes = Object.entries(detalhe.alteracoes || {}).map(([campo, { de, para }]) =>
      `${CAMPO_LABEL[campo] || campo}: ${de ? formatDate(de) : '(vazio)'} → ${para ? formatDate(para) : '(vazio)'}`
    )
    return `${detalhe.indicador || ''} · ${MESES[(detalhe.mes || 1) - 1]}/${detalhe.ano || ''} · ${partes.join(' · ')}`
  }
  return JSON.stringify(detalhe)
}

export default function Logs() {
  const { isSuperAdmin, selectedCompany } = useAuth()
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)
  const [filtroAcao, setFiltroAcao] = useState('')
  const [filtroUser, setFiltroUser] = useState('')
  const [usuarios, setUsuarios] = useState([])

  useEffect(() => {
    let q = supabase.from('profiles').select('id, nome').order('nome')
    if (isSuperAdmin && selectedCompany) q = q.eq('company_id', selectedCompany.id)
    q.then(({ data }) => setUsuarios(data || []))
  }, [selectedCompany])

  useEffect(() => { fetchLogs() }, [filtroAcao, filtroUser, selectedCompany])

  async function fetchLogs() {
    setLoading(true)
    let q = supabase.from('logs')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(500)
    if (isSuperAdmin && selectedCompany) q = q.eq('company_id', selectedCompany.id)
    if (filtroAcao) q = q.eq('acao', filtroAcao)
    if (filtroUser) q = q.eq('user_id', filtroUser)
    const { data, error } = await q
    if (error) console.error('[logs]', error)
    setLogs(data || [])
    setLoading(false)
  }

  return (
    <div>
      <div className="page-title">
        <div>
          <h2>Logs</h2>
          <p style={{ color: 'var(--text2)', fontSize: 13, marginTop: 2 }}>Registro de atividades do sistema</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <select value={filtroUser} onChange={e => setFiltroUser(e.target.value)} style={{ width: 'auto', minWidth: 160 }}>
            <option value="">Todos os usuários</option>
            {usuarios.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}
          </select>
          <select value={filtroAcao} onChange={e => setFiltroAcao(e.target.value)} style={{ width: 'auto' }}>
            <option value="">Todas as ações</option>
            {Object.entries(ACOES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </div>
      </div>

      <div className="card" style={{ padding: 0 }}>
        {loading ? (
          <div className="empty-state">Carregando...</div>
        ) : logs.length === 0 ? (
          <div className="empty-state">Nenhum registro encontrado.</div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th style={{ whiteSpace: 'nowrap' }}>Data/Hora</th>
                  <th>Usuário</th>
                  <th>Ação</th>
                  <th>Detalhe</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(entry => (
                  <tr key={entry.id}>
                    <td style={{ fontFamily: 'var(--mono)', fontSize: 12, whiteSpace: 'nowrap' }}>{formatDate(entry.created_at)}</td>
                    <td style={{ fontSize: 13 }}>{usuarios.find(u => u.id === entry.user_id)?.nome || '—'}</td>
                    <td>
                      <span className={`badge ${entry.acao === 'login' ? 'badge-blue' : entry.acao === 'fca_criado' ? 'badge-amber' : entry.acao === 'fca_data_alterada' ? 'badge-amber' : 'badge-gray'}`}>
                        {ACOES[entry.acao] || entry.acao}
                      </span>
                    </td>
                    <td style={{ fontSize: 12, color: 'var(--text2)' }}>{formatDetalhe(entry.acao, entry.detalhe)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}
